export default __webpack_public_path__ + "static/Naveed-60e622e2f77da129bd3812a5bf962e8a.jpg";